import { render, staticRenderFns } from "./WelfareAllowance.vue?vue&type=template&id=d57ab400&scoped=true&"
import script from "./WelfareAllowance.vue?vue&type=script&lang=js&"
export * from "./WelfareAllowance.vue?vue&type=script&lang=js&"
import style0 from "./WelfareAllowance.vue?vue&type=style&index=0&id=d57ab400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57ab400",
  null
  
)

export default component.exports